<template>
	<div class="c-editor">
		<div ref="div" :id="id"></div>
	</div>
</template>

<script>
	import './kindeditor/kindeditor-all.js'
	import './kindeditor/themes/default/default.css'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		name: 'cEditor',
		
		props: {
			value: String,
			name: [String, Number],
			height: {
				type: [String, Number],
				default: 300
			},
			autoHeight: Boolean
		},

		data() {
			return {
				...getStore(this, 'cFormStore'),
				...getStore(this, 'cFormItemStore'),
				id: `KindEditor${this._uid}`
			};
		},

		computed: {
			...mapStore('cFormItemStore', ['warnState']),
		},
		
		watch: {
			value(val) {
				this.set(val);
			}
		},
		
		mounted() {
			setTimeout(() => {
				if (!this.editor) {
					this.create();
				}
				if (this._afterInit) {
					this._afterInit();
				} else {
					this.set(this.value);
				}
			});
		},
		
		activated() {
			this.destroy();
			this.create();
		},
		
		beforeDestroy() {
			this.destroy();
		},

		methods: {
			set(val = '') {
				if (this.editor) {
					this.editor.html(val);
					this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				} else {
					this._afterInit = () => {
						this.set(val);
						delete this._afterInit;
					}
				}
			},
			
			get() {
				return this.editor.html();
			},
			
			create() {
				this.editor = KindEditor.create('#' + this.id, {
					width: '100%',
					height: this.height,
					resizeType: 1,
					autoHeightMode: !!this.autoHeight,
					afterFocus: () => {
						this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
					},
					afterBlur: () => {
						this.$emit('input', this.get());
						this.cFormStore && this.cFormStore.commit('editState', true);
					}
				});
			},
			
			destroy() {
				this.editor && this.editor.remove();
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.c-editor {
		>>> .ke-container {
			box-sizing: border-box;
		}
	}
</style>